import BaseRepository from '@/baseRepository/BaseRepository';
import qs from "qs";
const resource = `/api/v1/settings`;
const supplierResource = `/api/v1/merchants/main-client`;
 
export default {
  getSettings(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
 
  updateSettings(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
      
    });
  },
   getSuppliersByIds( baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierResource}/merchants-byids`,   {
      baseURL,
      headers,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "indices" });
      },
    });
  },
     getSuppliersByNameFilter( baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${supplierResource}/merchants-filter`,   {
      baseURL,
      headers,
      params,
    });
  },
};
